<template>
  <Modal :id="'cmp-add-invoice-modal'" :loading="loading" @cancelled="onCancel">
    <template slot="header">{{$t('new_invoice')}}</template>

    <template slot="body">
      <div class="form-group" v-if="!loading">
        <Dropdown
          :options="invoice_projectsTV"
          :id="'invoiceProject'"
          class="m2"
          :selected="invoiceProject"
          :placeholder="$t('invoice_project')"
          v-on:selectedChange="(e) => onDropdownChange('invoiceProject', e)"
          box
          :listHeight="250"
        ></Dropdown>
        <Dropdown
          :options="currencyTV"
          :id="'currency'"
          class="m2"
          :selected="currency"
          :placeholder="$t('currency')"
          v-on:selectedChange="(e) => onDropdownChange('currency', e)"
          box
          :listHeight="250"
        ></Dropdown>
      </div>
      <LoadingTextUI v-else height="115px" :text="loadingText" />
    </template>
    <template slot="options">
      <button
        class="dt-button s6"
        @click.stop="onCancel"
        style="min-width: 132px"
      >
        {{$t('cancel')}}
      </button>
      <button
        class="dt-button v1 with-ico"
        @click.stop="addNewInvoice"
        :class="{ disabled: loading }"
        :disabled="loading"
        style="min-width: 158px"
      >
        <div class="dt-icon-container">
          <img src="static/icons/plus-white.svg" class="dt-icon v7" alt />
        </div>
        <div class="button-text">
          {{ $t("create_new") }} {{ $t("invoice") }}
        </div>
      </button>
    </template>
  </Modal>
</template>

<script>
import { InvoicesService } from "../../services/invoices.service";
import Modal from "@dtplugins/modal/modal";
import { LoadingTextUI } from "../../../../plugins/loading/loading-helper";

export default {
  components: {
    Modal,
    LoadingTextUI,
  },
  props: {
    invoice_projectsTV: {
      type: Array,
    },
    currencyTV: {
      type: Array,
    },
    defaultCurrency: {
      type: String,
    },
  },
  data: function () {
    return {
      textFieldConfig: {
        height: 42,
        showEditIconOnHover: false,
        box: true,
        showValidationIcons: true,
      },
      loading: false,
      loadingText: "Creating Invoice",

      invoiceProject: null,
      currency: null,
    };
  },
  watch: {
    defaultCurrency: {
      immediate: true,
      handler: function (newDefaultCurrency) {
        // console.log({ defaultCurrency: newDefaultCurrency });
        if (this.currencyTV && this.currencyTV.length > 0) {
          this.currency = this.currencyTV?.find(
            (e) => e.text === newDefaultCurrency
          );
        }
      },
    },
    currencyTV: {
      immediate: true,
      handler: function (newCurrencyTV) {
        // console.log({ currencyTV: newCurrencyTV });
        if (this.defaultCurrency) {
          this.currency = newCurrencyTV?.find(
            (e) => e.text === this.defaultCurrency
          );
        }
      },
    },
  },
  mounted: function () {
    // console.log();
    // setTimeout(() => {
    // this.currency = {
    //   text: this.$store.getters.account.client.default_currency,
    //   value: this.$store.getters.account.client.default_currency,
    // };
    // this.currency = this.currencyTV?.find(e => e.text === this.$store.getters.account.client.default_currency);
    // console.log({ "this.currency": this.currency });
    // }, 500);
  },
  computed: {
    selectedGroups: function () {
      return this.contactType === "person"
        ? this.person.groups
        : this.company.groups;
    },
    isFormValid: function () {
      return this.invoiceProject && this.currency;
    },
  },
  methods: {
    onCancel: function () {
      this.$emit("cancelled", true);
    },
    addNewInvoice: async function (e) {
      this.loading = true;
      const invoice = await InvoicesService.createInvoice({
        invoice_user_id: this.$store.getters.account.user.user_id,
        invoice_project_id: this.invoiceProject.value,
        currency_id: this.currency.value,
      });
      this.$emit("created", invoice.data.invoice);
    },
    onDropdownChange: function (name, value) {
      // console.log(name, value);
      this[name] = value;
    },
    //MARK: Methods
  },
};
</script>

<style lang="scss">
.cmp-add-invoice-modal {
}
</style>
